import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
     Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const CorrectedReportSupervisor = () => {
  const [supervisorPretherapy, setSupervisorPretherapy] = useState({
    opNumber: '',
    caseName: '',
    age: '',
    language: '',
    device: '',
    studentName: '',
    email: '',
    pretherapyFile: null
  });
 const [loading, setLoading] = useState(false);
    const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
    const [openPasswordModal, setOpenPasswordModal] = useState(false);
    const [password, setPassword] = useState('');
    const [downloadFormat, setDownloadFormat] = useState('excel');
  const [supervisorLessonPlan, setSupervisorLessonPlan] = useState({
    opNumber: '',
    caseName: '',
    age: '',
    lessonPlanFile: null,
    device: '',
    studentName: '',
    email: ''
  });

  const [supervisorProgressReport, setSupervisorProgressReport] = useState({
    opNumber: '',
    caseName: '',
    age: '',
    reportFile: null,
    device: '',
    studentName: '',
    email: ''
  });

  const languageOptions = ['Kannada', 'Hindi', 'Malayalam', 'Telugu', 'Tamil', 'English'];
  const deviceOptions = ['Hearing aid', 'CI', 'Hearing aid + CI', 'Bilateral CI'];

  // Supervisor Pretherapy Handlers
  const handleSupervisorPretherapyChange = (field, value) => {
    setSupervisorPretherapy(prev => ({ ...prev, [field]: value }));
  };
 const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Supervisor Pretherapy ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "supervisor_pretherapy",
          formName: "Supervisor_Pretherapy",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Supervisor_Pretherapy_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };
  const handleSupervisorPretherapySubmit = async () => {
    try {
      // Basic validation
      if (!supervisorPretherapy.email || !supervisorPretherapy.email.includes('@')) {
        alert("Please enter a valid email address");
        return;
      }

      if (!supervisorPretherapy.pretherapyFile) {
        alert("Please upload a pretherapy file");
        return;
      }

      const formData = new FormData();
      formData.append('op_number', supervisorPretherapy.opNumber);
      formData.append('case_name', supervisorPretherapy.caseName);
      formData.append('age', supervisorPretherapy.age);
      formData.append('language', supervisorPretherapy.language);
      formData.append('device', supervisorPretherapy.device);
      formData.append('student_name', supervisorPretherapy.studentName);
      formData.append('email', supervisorPretherapy.email);
      formData.append('pretherapy_file', supervisorPretherapy.pretherapyFile);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/corrected-report/supervisor-pretherapy`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok && data.success) {
        alert("Supervisor pretherapy submitted successfully! Confirmation email sent.");
        setSupervisorPretherapy({
          opNumber: '', caseName: '', age: '', language: '', device: '',
          studentName: '', email: '', pretherapyFile: null
        });
      } else {
        throw new Error(data.message || 'Failed to submit supervisor pretherapy');
      }
    } catch (error) {
      alert("Error submitting supervisor pretherapy: " + error.message);
    }
  };

  // Supervisor Lesson Plan Handlers
  const handleSupervisorLessonPlanChange = (field, value) => {
    setSupervisorLessonPlan(prev => ({ ...prev, [field]: value }));
  };

  const handleSupervisorLessonPlanSubmit = async () => {
    try {
      // Basic validation
      if (!supervisorLessonPlan.email || !supervisorLessonPlan.email.includes('@')) {
        alert("Please enter a valid email address");
        return;
      }

      if (!supervisorLessonPlan.lessonPlanFile) {
        alert("Please upload a lesson plan file");
        return;
      }

      const formData = new FormData();
      formData.append('op_number', supervisorLessonPlan.opNumber);
      formData.append('case_name', supervisorLessonPlan.caseName);
      formData.append('age', supervisorLessonPlan.age);
      formData.append('device', supervisorLessonPlan.device);
      formData.append('student_name', supervisorLessonPlan.studentName);
      formData.append('email', supervisorLessonPlan.email);
      formData.append('lesson_plan_file', supervisorLessonPlan.lessonPlanFile);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/corrected-report/supervisor-lesson-plans`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok && data.success) {
        alert("Supervisor lesson plan submitted successfully! Confirmation email sent.");
        setSupervisorLessonPlan({
          opNumber: '', caseName: '', age: '', lessonPlanFile: null, device: '',
          studentName: '', email: ''
        });
      } else {
        throw new Error(data.message || 'Failed to submit supervisor lesson plan');
      }
    } catch (error) {
      alert("Error submitting supervisor lesson plan: " + error.message);
    }
  };

  // Supervisor Progress Report Handlers
  const handleSupervisorProgressReportChange = (field, value) => {
    setSupervisorProgressReport(prev => ({ ...prev, [field]: value }));
  };

  const handleSupervisorProgressReportSubmit = async () => {
    try {
      // Basic validation
      if (!supervisorProgressReport.email || !supervisorProgressReport.email.includes('@')) {
        alert("Please enter a valid email address");
        return;
      }

      if (!supervisorProgressReport.reportFile) {
        alert("Please upload a progress report file");
        return;
      }

      const formData = new FormData();
      formData.append('op_number', supervisorProgressReport.opNumber);
      formData.append('case_name', supervisorProgressReport.caseName);
      formData.append('age', supervisorProgressReport.age);
      formData.append('device', supervisorProgressReport.device);
      formData.append('student_name', supervisorProgressReport.studentName);
      formData.append('email', supervisorProgressReport.email);
      formData.append('report_file', supervisorProgressReport.reportFile);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/corrected-report/supervisor-progress-reports`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok && data.success) {
        alert("Supervisor progress report submitted successfully! Confirmation email sent.");
        setSupervisorProgressReport({
          opNumber: '', caseName: '', age: '', reportFile: null, device: '',
          studentName: '', email: ''
        });
      } else {
        throw new Error(data.message || 'Failed to submit supervisor progress report');
      }
    } catch (error) {
      alert("Error submitting supervisor progress report: " + error.message);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 1200, margin: 'auto' }}>
         <Box sx={{ position: 'absolute', top: 300, right: 140 }}>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<DownloadIcon />}
                      onClick={handleDownloadClick}
                      disabled={loading}
                      sx={{ 
                        borderRadius: 2,
                        boxShadow: 2,
                        '&:hover': {
                          boxShadow: 4,
                          transform: 'translateY(-2px)',
                          transition: 'all 0.3s ease'
                        }
                      }}
                    >
                      Download 
                    </Button>
                  </Box>
      <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
        Corrected Reports (Supervisor)
      </Typography>

      {/* Supervisor Pretherapy Section */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
          Supervisor Pretherapy
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="IP/OP/Internal No"
              value={supervisorPretherapy.opNumber}
              onChange={(e) => handleSupervisorPretherapyChange('opNumber', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Case Name"
              value={supervisorPretherapy.caseName}
              onChange={(e) => handleSupervisorPretherapyChange('caseName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Age"
              value={supervisorPretherapy.age}
              onChange={(e) => handleSupervisorPretherapyChange('age', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true}>Language</InputLabel>
              <Select
                value={supervisorPretherapy.language}
                onChange={(e) => handleSupervisorPretherapyChange('language', e.target.value)}
                label="Language"
                displayEmpty
                renderValue={value => value || 'Select Language'}
              >
                {languageOptions.map((lang) => (
                  <MenuItem key={lang} value={lang}>{lang}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true}>Device</InputLabel>
              <Select
                value={supervisorPretherapy.device}
                onChange={(e) => handleSupervisorPretherapyChange('device', e.target.value)}
                label="Device"
                displayEmpty
                renderValue={value => value || 'Select Device'}
              >
                {deviceOptions.map((device) => (
                  <MenuItem key={device} value={device}>{device}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Student Name"
              value={supervisorPretherapy.studentName}
              onChange={(e) => handleSupervisorPretherapyChange('studentName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={supervisorPretherapy.email}
              onChange={(e) => handleSupervisorPretherapyChange('email', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Button variant="contained" component="label" fullWidth sx={{ py: 1.5 }}>
              {supervisorPretherapy.pretherapyFile ? 'File Selected: ' + supervisorPretherapy.pretherapyFile.name : 'Upload Pretherapy File'}
              <input
                type="file"
                hidden
                onChange={(e) => handleSupervisorPretherapyChange('pretherapyFile', e.target.files[0])}
                accept=".pdf,.doc,.docx,.txt"
              />
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSupervisorPretherapySubmit}
              fullWidth
            >
              Submit Supervisor Pretherapy
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Supervisor Lesson Plan Section */}
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
          Supervisor Lesson Plan
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="OP Number"
              value={supervisorLessonPlan.opNumber}
              onChange={(e) => handleSupervisorLessonPlanChange('opNumber', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Case Name"
              value={supervisorLessonPlan.caseName}
              onChange={(e) => handleSupervisorLessonPlanChange('caseName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Age"
              value={supervisorLessonPlan.age}
              onChange={(e) => handleSupervisorLessonPlanChange('age', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true}>Device</InputLabel>
              <Select
                value={supervisorLessonPlan.device}
                onChange={(e) => handleSupervisorLessonPlanChange('device', e.target.value)}
                label="Device"
                displayEmpty
                renderValue={value => value || 'Select Device'}
              >
                {deviceOptions.map((device) => (
                  <MenuItem key={device} value={device}>{device}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <Button variant="contained" component="label" fullWidth sx={{ py: 1.5 }}>
              {supervisorLessonPlan.lessonPlanFile ? 'File Selected: ' + supervisorLessonPlan.lessonPlanFile.name : 'Upload Lesson Plan'}
              <input
                type="file"
                hidden
                onChange={(e) => handleSupervisorLessonPlanChange('lessonPlanFile', e.target.files[0])}
                accept=".pdf,.doc,.docx,.txt"
              />
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Student Name"
              value={supervisorLessonPlan.studentName}
              onChange={(e) => handleSupervisorLessonPlanChange('studentName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={supervisorLessonPlan.email}
              onChange={(e) => handleSupervisorLessonPlanChange('email', e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSupervisorLessonPlanSubmit}
              fullWidth
            >
              Submit Supervisor Lesson Plan
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Supervisor Progress Report Section */}
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
          Supervisor Progress Report
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="OP Number"
              value={supervisorProgressReport.opNumber}
              onChange={(e) => handleSupervisorProgressReportChange('opNumber', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Case Name"
              value={supervisorProgressReport.caseName}
              onChange={(e) => handleSupervisorProgressReportChange('caseName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Age"
              value={supervisorProgressReport.age}
              onChange={(e) => handleSupervisorProgressReportChange('age', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel shrink={true}>Device</InputLabel>
              <Select
                value={supervisorProgressReport.device}
                onChange={(e) => handleSupervisorProgressReportChange('device', e.target.value)}
                label="Device"
                displayEmpty
                renderValue={value => value || 'Select Device'}
              >
                {deviceOptions.map((device) => (
                  <MenuItem key={device} value={device}>{device}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <Button variant="contained" component="label" fullWidth sx={{ py: 1.5 }}>
              {supervisorProgressReport.reportFile ? 'File Selected: ' + supervisorProgressReport.reportFile.name : 'Upload Progress Report'}
              <input
                type="file"
                hidden
                onChange={(e) => handleSupervisorProgressReportChange('reportFile', e.target.files[0])}
                accept=".pdf,.doc,.docx,.txt"
              />
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Student Name"
              value={supervisorProgressReport.studentName}
              onChange={(e) => handleSupervisorProgressReportChange('studentName', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={supervisorProgressReport.email}
              onChange={(e) => handleSupervisorProgressReportChange('email', e.target.value)}
              required
            />
          </Grid>
                <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSupervisorProgressReportSubmit}
              fullWidth
            >
              Submit Supervisor Progress Report
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default CorrectedReportSupervisor;